import PrizeBadge from '../ScopedBlock/PrizeBadge.svg?url'
import { Button } from './Button'
import React from 'react'
import { LinkButton } from './LinkButton'
import { IntegrationServiceId } from '../../common/integrations'

interface CommonButtonProps {
  onClick: () => void
  isDisabled?: boolean
}

export const RevokeMyAccessButton: React.FC<CommonButtonProps> = ({ onClick, isDisabled = false }) => {
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <div className='d-flex' onClick={stopPropagation} onContextMenu={stopPropagation} onMouseDown={stopPropagation} onAuxClick={stopPropagation}>
      <Button variant='primaryGhost' className='w-100' onClick={onClick} disabled={isDisabled}>
        Revoke my access
      </Button>
    </div>
  )
}

export const UpgradeButton: React.FC<CommonButtonProps> = ({ onClick, isDisabled = false }) => {
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <div
      className='d-flex align-self-stretch'
      onClick={stopPropagation}
      onContextMenu={stopPropagation}
      onMouseDown={stopPropagation}
      onAuxClick={stopPropagation}
    >
      <Button variant='primary' className='w-100' onClick={onClick} disabled={isDisabled}>
        <img alt='Upgrade' src={PrizeBadge} />
        Upgrade
      </Button>
    </div>
  )
}

export const DisableButton: React.FC<CommonButtonProps> = ({ onClick, isDisabled = false }) => {
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <div className='d-flex' onClick={stopPropagation} onContextMenu={stopPropagation} onMouseDown={stopPropagation} onAuxClick={stopPropagation}>
      <Button variant='primaryGhost' className='w-100' onClick={onClick} disabled={isDisabled}>
        Disable
      </Button>
    </div>
  )
}

export const EnableButton: React.FC<CommonButtonProps> = ({ onClick, isDisabled = false }) => {
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <div className='d-flex' onClick={stopPropagation} onContextMenu={stopPropagation} onMouseDown={stopPropagation} onAuxClick={stopPropagation}>
      <Button variant='primary' className='w-100' onClick={onClick} disabled={isDisabled}>
        Enable
      </Button>
    </div>
  )
}

interface ManageButtonProps {
  isDisabled?: boolean
  to: string
}

export const ManageButton: React.FC<ManageButtonProps> = ({ isDisabled = false, to }) => {
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    if (isDisabled) {
      e.preventDefault()
    }
  }

  return (
    <div className='d-flex' onClick={stopPropagation} onContextMenu={stopPropagation} onMouseDown={stopPropagation} onAuxClick={stopPropagation}>
      <LinkButton variant='primaryGhost' className='w-100' disabled={isDisabled} to={to}>
        Manage
      </LinkButton>
    </div>
  )
}

const CONNECT_BUTTON_LABELS: Partial<Record<IntegrationServiceId, string>> = {
  [IntegrationServiceId.DELEGATED_EMAIL]: 'Link email',
}

interface ConnectButtonProps {
  serviceId: IntegrationServiceId
  onClick: () => void
  isDisabled?: boolean
}

export const ConnectButton: React.FC<ConnectButtonProps> = ({ serviceId, onClick, isDisabled = false }) => {
  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }

  const label = CONNECT_BUTTON_LABELS[serviceId] ?? 'Connect'

  return (
    <div className='d-flex' onClick={stopPropagation} onContextMenu={stopPropagation} onMouseDown={stopPropagation} onAuxClick={stopPropagation}>
      <Button variant='primary' className='w-100' onClick={onClick} disabled={isDisabled}>
        {label}
      </Button>
    </div>
  )
}
